import { render, staticRenderFns } from "./AnnotateLabelGroups.vue?vue&type=template&id=0ca41834&scoped=true"
import script from "./AnnotateLabelGroups.vue?vue&type=script&lang=js"
export * from "./AnnotateLabelGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca41834",
  null
  
)

export default component.exports